import React from 'react'

import Tab from 'src/components/Tab'

import DinheiroDeVoltaNoShopping from './tabs/dinheiro-de-volta-no-shopping/_index'
import EmprestimoPessoalEFinanciamentoImobiliario from './tabs/emprestimo-pessoal-e-financiamento-imobiliario/_index'
import InterInvestimentos from './tabs/inter-investimentos/_index'
import InterSeguros from './tabs/inter-seguros/_index'

import { TabSection } from './style'

const MaisQueUmBancoDigital = () => {
  const [ , setTabPosition ] = React.useState<number>(0)
  return (
    <TabSection className='pb-0 bg-grayscale--100'>
      <div className='container'>
        <div className='col-12'>
          <h2 className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 fw-600 font-sora text-grayscale--500 text-center mb-3'>
            Mais que um banco digital, somos Inter!
          </h2>
          <p className='fs-14 lh-17 fs-lg-16 lh-lg-20 fs-xl-18 lh-xl-22 fw-400 text-grayscale--400 text-center mb-5'>
            E ser Inter significa contratar um seguro, comprar no Inter Shop com cashback, recarregar seu celular e muito mais.
            Tudo simples, tudo em apenas um Super App.
          </p>
        </div>
        <div className='col-12 px-0'>
          <Tab
            styles='fs-14 lh-16 fw-700'
            items={[ 'Investimentos', 'Empréstimos e Financiamento', 'Seguros', 'Shopping' ]}
            setTabPosition={setTabPosition}
          >
            <InterInvestimentos />
            <EmprestimoPessoalEFinanciamentoImobiliario />
            <InterSeguros />
            <DinheiroDeVoltaNoShopping />
          </Tab>
        </div>
      </div>
    </TabSection>
  )
}

export default MaisQueUmBancoDigital
